/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TelecommunicationEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const TelecommunicationEnum = {
    NUMBER_1: 1 as TelecommunicationEnum,
    NUMBER_2: 2 as TelecommunicationEnum,
    NUMBER_3: 3 as TelecommunicationEnum,
    NUMBER_4: 4 as TelecommunicationEnum,
    NUMBER_5: 5 as TelecommunicationEnum,
    NUMBER_6: 6 as TelecommunicationEnum,
    NUMBER_7: 7 as TelecommunicationEnum
};

